import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Layout from '../../../components/Layout'
import Seo from '../../../components/Seo'
import {
  seo,
  intro,
  main,
  blog,
  upcoming,
} from '../../../content/omida-bulldogs'
import { useLangContext } from '../../../context/lang.context'
import Intro from '../../../components/Intro'
import Main from '../../../components/Main'
import { sBlogs } from '../../../sections/index/BlogSection'
import BlogTile from '../../../components/BlogTile'

const OmidaBulldogs = () => {
  const { lang } = useLangContext()

  const query = useStaticQuery(graphql`
    {
      image: file(
        absolutePath: { regex: "/images/intros/omida-bulldogs.jpeg/" }
      ) {
        publicURL
        childImageSharp {
          gatsbyImageData(
            layout: FIXED
            quality: 100
            placeholder: BLURRED
            formats: [JPG]
          )
        }
      }
      imageAbout: file(
        absolutePath: { regex: "/images/supporting/wasiewicz/wasiewicz.jpg/" }
      ) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            quality: 100
            placeholder: BLURRED
            formats: [JPG]
            aspectRatio: 1
          )
        }
      }
      blogs: allContentfulBlog(
        filter: {
          blog_categories: { elemMatch: { blog_category: { eq: "Omida Splash Brothers" } } }
        }
      ) {
        nodes {
          blog_slug
          lang {
            slug
          }
          blog_categories {
            blog_category
          }
          title
          description
          image {
            gatsbyImageData(
              layout: CONSTRAINED
              quality: 100
              placeholder: DOMINANT_COLOR
              formats: [JPG]
              aspectRatio: 1.77
            )
          }
        }
      }
    }
  `)

  const blogs = query.blogs.nodes.map(
    ({ title, description, image, blog_slug }) => ({
      title,
      desc: description,
      slug: blog_slug,
      image,
    })
  )

  const button = {
    text: {
      pl: 'Przeglądaj',
      en: 'Explore',
    },
    action: 'SCROLL',
  }

  return (
    <Layout>
      <Seo
        title={seo.title[lang]}
        desc={seo.desc[lang]}
        url={seo.url}
        keywords={seo.keywords}
      />
      <Intro
        data={{ ...intro, button }}
        image={query.image.childImageSharp}
        position='center'
      />
      <Main h={2} s={1} title={main.title[lang]} body={main.body[lang]}>
      </Main>
      <Main
        h={2}
        s={1}
        title={blog.title[lang]}
        desc={blog.desc[lang]}
        subtitle={'Sea & Air Blog'}
      >
        <div css={sBlogs}>
          {blogs.map((blog, id) => (
            <BlogTile key={id} data={blog} />
          ))}
        </div>
      </Main>
    </Layout>
  )
}

export default OmidaBulldogs
